export class HisJobOption {
    jobConfiguration: string; // the guid of the job configuration item from which this instance was created
    key: string;  // key that allows HISinOne to identify the job
    name: string; // displayname
    sortorder?: number; // TODO: nötig? Evtl ist die Liste bereits auf dem Server sortiert
    quickstarterIcon?: string; // Icon-Name for quick start button if job should be displayed as favorite
    forceShowConfig?: boolean; // if true, always open the config panel if job is selected
    defaultJobSettings?: any[]; // Configurable Settings für this job
}
